<div class="vc_row wpb_row vc_row-fluid vc_custom_1453824797673">
  <div class="wpb_column vc_column_container vc_col-sm-12 vc_custom_1452525768861">
    <div class="vc_column-inner">
      <div class="wpb_wrapper">
        <div class="wpb_revslider_element wpb_content_element">
          <div class="rev_slider_wrapper fullwidthbanner-container">
            <div id="rev_slider_home_base" class="rev_slider fullwidthabanner dd-home-slider" aria-label="Home carousel">
              <ul class="dd-home-slider__slides">
                @for (slide of slides; track slide.image; let i = $index) {
                  <li
                    class="dd-home-slider__slide"
                    [class.is-active]="active() === i"
                    [attr.aria-hidden]="active() === i ? null : true"
                  >
                    <img
                      [src]="slide.image"
                      [srcset]="slide.srcset"
                      sizes="100vw"
                      [alt]="slide.alt"
                      width="1900"
                      height="600"
                      decoding="async"
                      [class.dd-kenburns]="active() === i"
                      [class.dd-kenburns--right]="slide.kenBurns === 'right'"
                    />
                  </li>
                }
              </ul>

              <button
                type="button"
                class="dd-home-slider__arrow dd-home-slider__arrow--prev"
                (click)="prev($event)"
                aria-label="Previous slide"
              >
                <span aria-hidden="true"></span>
              </button>
              <button
                type="button"
                class="dd-home-slider__arrow dd-home-slider__arrow--next"
                (click)="next($event)"
                aria-label="Next slide"
              >
                <span aria-hidden="true"></span>
              </button>

              <div class="dd-home-slider__bullets" role="tablist" aria-label="Slide navigation">
                @for (slide of slides; track slide.image; let i = $index) {
                  <button
                    type="button"
                    role="tab"
                    class="dd-home-slider__bullet"
                    [class.is-active]="active() === i"
                    [attr.aria-selected]="active() === i"
                    [attr.aria-label]="'Slide ' + (i + 1)"
                    (click)="goTo(i)"
                  ></button>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
